"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgLeafFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M13.046 20a8 8 0 008-8V7.045A3.044 3.044 0 0018 4h-4.955a8 8 0 00-6.382 12.825l-.89.881a3.906 3.906 0 01-2.747 1.133H3a1 1 0 100 2h.027c1.558 0 3.05-.618 4.155-1.712l.879-.87A7.966 7.966 0 0013.046 20zM16.2 8.787a1 1 0 00-1.414.012l-.085.086-.247.25A425.296 425.296 0 0112 11.6V9.556a1 1 0 10-2 0V14a1 1 0 001 1h4.444a1 1 0 100-2h-2.017a548.354 548.354 0 002.45-2.458l.25-.253.086-.088a1 1 0 00-.012-1.414z' }))); };
exports.default = SvgLeafFilled;
//# sourceMappingURL=LeafFilled.js.map